export default __webpack_public_path__ + "static/media/logo.da2e5e28.png";